class GroupStatuses {
  constructor() {
    
    let statuses = {
      'active': 1,
      'archived': 0
    }

    this.getKeyByValue = (value) => {
      let values = Object.values(statuses)
      let key = values.find(key => values[key] === value)
      return Object.keys(statuses)[key];
    }

    this.getStatuses = () => {
      return statuses
    }
  }
  
}
export default new GroupStatuses